// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.priorityIndicator_indicator__d4tAp {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 2px;
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_urgentBox__xYEzS {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-weight: 700;
  font-size: 14px;
  background-color: var(--grayLightColor);
  color: var(--grayColor);
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_indicatorBar__wuijD {
  width: 5px;
  background-color: var(--grayLightColor);
  border-radius: 2px;
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_indicatorBar__wuijD:nth-of-type(1) {
  height: 10px;
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_indicatorBar__wuijD:nth-of-type(2) {
  height: 15px;
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_indicatorBar__wuijD:nth-of-type(3) {
  height: 20px;
}
.priorityIndicator_indicator__d4tAp .priorityIndicator_indicatorBar__wuijD.priorityIndicator_active__JxRuH {
  background-color: var(--grayColor);
}
.priorityIndicator_indicator__d4tAp.priorityIndicator_onAccent__6XzfE .priorityIndicator_indicatorBar__wuijD {
  background-color: var(--grayLightOnAccentColor);
}
.priorityIndicator_indicator__d4tAp.priorityIndicator_onAccent__6XzfE .priorityIndicator_indicatorBar__wuijD.priorityIndicator_active__JxRuH {
  background-color: var(--grayOnAccentColor);
}
.priorityIndicator_indicator__d4tAp.priorityIndicator_onAccent__6XzfE .priorityIndicator_urgentBox__xYEzS {
  background-color: var(--grayLightOnAccentColor);
  color: var(--grayOnAccentColor);
}`, "",{"version":3,"sources":["webpack://./src/components/priorityIndicator/priorityIndicator.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;AADJ;AAGI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,uBAAA;AADR;AAII;EACI,UAAA;EACA,uCAAA;EACA,kBAAA;AAFR;AAIQ;EACI,YAAA;AAFZ;AAKQ;EACI,YAAA;AAHZ;AAMQ;EACI,YAAA;AAJZ;AAOQ;EACI,kCAAA;AALZ;AAUQ;EACI,+CAAA;AARZ;AAUY;EACI,0CAAA;AARhB;AAWQ;EACI,+CAAA;EACA,+BAAA;AATZ","sourcesContent":["\n\n.indicator {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 2px;\n\n    .urgentBox {\n        width: 18px;\n        height: 18px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 2px;\n        font-weight: 700;\n        font-size: 14px;\n        background-color: var(--grayLightColor);\n        color: var(--grayColor);\n    }\n\n    .indicatorBar {\n        width: 5px;\n        background-color: var(--grayLightColor);\n        border-radius: 2px;\n\n        &:nth-of-type(1) {\n            height: 10px;\n        }\n\n        &:nth-of-type(2) {\n            height: 15px;\n        }\n\n        &:nth-of-type(3) {\n            height: 20px;\n        }\n\n        &.active {\n            background-color: var(--grayColor);\n        }\n    }\n\n    &.onAccent {\n        .indicatorBar {\n            background-color: var(--grayLightOnAccentColor);\n\n            &.active {\n                background-color: var(--grayOnAccentColor);\n            }\n        }\n        .urgentBox {\n            background-color: var(--grayLightOnAccentColor);\n            color: var(--grayOnAccentColor);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indicator": `priorityIndicator_indicator__d4tAp`,
	"urgentBox": `priorityIndicator_urgentBox__xYEzS`,
	"indicatorBar": `priorityIndicator_indicatorBar__wuijD`,
	"active": `priorityIndicator_active__JxRuH`,
	"onAccent": `priorityIndicator_onAccent__6XzfE`
};
export default ___CSS_LOADER_EXPORT___;
